module.exports = __webpack_public_path__ + "static/media/flightimage.ecf48204.svg";